import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { SegmentedControl } from "@msuite/ui/segmented-control";
import { getAttendanceStateColor } from "@msuite/utils/attendances";

export type AttendanceStateFilter = "all" | "pending" | "approved" | "rejected";

/** Props Interface */
interface UserAttendanceStatePickerProps {
	value: AttendanceStateFilter;
	onChange: (value: AttendanceStateFilter) => void;
}

export function UserAttendanceStatePicker({ value, onChange }: UserAttendanceStatePickerProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<SegmentedControl
			value={value}
			items={[
				{
					label: t("general.all"),
					value: "all",
					cyId: "attendance-state-picker-all",
					leftIcon: <Icon name="GalleryVerticalEnd" />,
				},
				{
					label: t("users.attendance_state.pending"),
					value: "pending",
					cyId: "attendance-state-picker-pending",
					leftIcon: (
						<Icon
							name="Clock"
							stroke={`var(--color-${getAttendanceStateColor("pending")}-500`}
						/>
					),
				},
				{
					label: t("users.attendance_state.approved"),
					value: "approved",
					cyId: "attendance-state-picker-approved",
					leftIcon: (
						<Icon
							name="Check"
							stroke={`var(--color-${getAttendanceStateColor("approved")}-500`}
						/>
					),
				},
				{
					label: t("users.attendance_state.rejected"),
					value: "rejected",
					cyId: "attendance-state-picker-rejected",
					leftIcon: (
						<Icon
							name="XCircle"
							stroke={`var(--color-${getAttendanceStateColor("rejected")}-500`}
						/>
					),
				},
			]}
			onChange={(v) => onChange(v as AttendanceStateFilter)}
		/>
	);
}
